
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  if(Flits.Metafields.IS_WISHLIST_PAID && Flits.Metafields.IS_WISHLIST_ENABLE){
    Flits.LoadStyleScript('wishlistJs',window.flitsObjects.allCssJs.wishlistJs.url);
  }
    
  
  function wishlistLocalDataCustom() {
    var wishlitsLocalHandles = Flits.getLocalStorage(Flits.wishlistButton.settings.wishlistHandle);
    if (wishlitsLocalHandles) {
      var wishlitsLocalHandlesArray = wishlitsLocalHandles.split(',');
      console.log(wishlitsLocalHandlesArray.length);
      for (var i = 0; i < wishlitsLocalHandlesArray.length; i++) {
        var is_add_wsl;
        var s = Flits(".filts-wishlist-product-style [data-flits-product-handle='" + wishlitsLocalHandlesArray[i] + "']");
        Flits(s).hasClass('flits-wls-inactive') ? is_add_wsl = !0 : is_add_wsl = !1;
        if(is_add_wsl)
          Flits(s).animateWishlistButton(-1, Flits.t('Flits.locals.wishlisted_product_page.remove_from_wishlist_button', 'Remove from Wishlist'));
        else{
          Flits(s).animateWishlistButton(-1, Flits.t('Flits.locals.wishlisted_product_page.add_to_wishlist_button', 'Add to Wishlist'));
        }
      }
    }
  }
  
  var flitsAjaxQuickView = function(xhrOrFetch) {
    var url = this._url;
    (url.indexOf('view=quickview') !== -1 ) && Flits.dispatchEvent('Flits:quickViewUpdated', {
      response: this,
      xhrOrFetch: xhrOrFetch
    });
  };
  Flits.addAjaxEvents(flitsAjaxQuickView);
  Flits.addFetchEvents(flitsAjaxQuickView);
  
  Flits(document).on('Flits:quickViewUpdated', function(event){
    Flits.checkAndSetupWishlistDiv();
    wishlistLocalDataCustom();
  });
    
  // Start : Wishlist redirect user for login

  function flitsSetRedirectURL(){
    if(Flits('form[action="/account/login"]')){ 
      //  If checkout_url is present then replace the value       
      if(Flits("form[action='/account/login'] input[name='checkout_url']").length > 0){
        console.log("Changed the value of existing elemet.")  
        Flits("form[action='/account/login'] input[name='checkout_url']").val(location.href);
      }
      //If checkout_url is present not present then create a new element and append it to the form.       
      else{
        console.log("New element created..!")    
        Flits('<input>').attr({
          type: 'hidden',
          name: 'checkout_url',
          value: location.href
        }).appendTo("form[action='/account/login']");
      }
    }
  }


  if (!window.is_customer_login){   //   If customer is not logged in
    Flits(document).on('click', '.flits-wls-button', function(event){
      var el = Flits(this);
      Flits.wishlistButton.settings.clicked_add_button = el;
      var is_add;
      Flits(el).hasClass('flits-wls-inactive') ? is_add = !0 : is_add = !1;
      let customer_id = Flits(el).attr('data-flits-customer-id');
      let customer_email = Flits(el).attr('data-flits-customer-email');
      let product_id = Flits(el).attr('data-flits-product-id');
      let product_handle = Flits(el).attr('data-flits-product-handle');
      let product_title = Flits(el).attr('data-flits-product-title');
      let product_image = Flits(el).attr('data-flits-product-image');
      let count = 0;
      let wsl_product_count = 0;
      let token = Flits.token;
      let add_url = Flits.base_url + Flits.wishlistButton.settings.wishlist_base_url + Flits.wishlistButton.settings.add_wsl_url;
      let remove_url = Flits.base_url + Flits.wishlistButton.settings.wishlist_base_url + Flits.wishlistButton.settings.remove_wsl_url;
      if (Flits.isNull(customer_email)) {
        let customer_email_cookie = Flits.getLocalStorage(Flits.cemail);      
        customer_email = customer_email_cookie;
      }
      var wishlist_data = {     
        scroll_top: document.documentElement.scrollTop,
        customer_hash: Flits.customerHash, token:token,
        method: 'POST',
        customer_id: customer_id,
        customer_email: customer_email,
        product_id: product_id,
        product_handle: product_handle,
        product_title: product_title,
        product_image: product_image,
        wsl_product_count: wsl_product_count,
        redirect_to : location.href
      };
      Flits.setLocalStorage('last_clicked_wishlist',wishlist_data);
      //         location.href = "/account/login";
      Flits("html").addClass("customer-show");
      flitsSetRedirectURL();
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

    });
  }
  Flits(window).load(function() {
    var last_clicked_wishlist = Flits.getLocalStorage('last_clicked_wishlist');
    if (last_clicked_wishlist) {
      var redirect_to = last_clicked_wishlist.redirect_to;   
      if(Flits("form#customer_login")){ 

        //          If checkout_url is present then replace the value       
        if(Flits("form#customer_login input[name='checkout_url']").length > 0){
          console.log("Changed the value of existing elemet.")  
          Flits("form#customer_login input[name='checkout_url']").val(redirect_to);
        }

        //          If checkout_url is present not present then create a new element and append it to the form.       
        else{
          console.log("New element created..!")    
          Flits('<input>').attr({
            type: 'hidden',
            name: 'checkout_url',
            value: redirect_to
          }).appendTo('form#customer_login');

        }
      }
      if(window.is_customer_login){          // To check if customer is logged in
        if(location.href == redirect_to ){
          var button = last_clicked_wishlist.click;
          Flits.setLocalStorage('last_clicked_wishlist','');
          setTimeout(function(){ 
            window.scrollTo(0,last_clicked_wishlist.scroll_top);            
            if(Flits('.flits-wls-button[data-flits-product-id="'+last_clicked_wishlist.product_id+'"]')){
              Flits('.flits-wls-button[data-flits-product-id="'+last_clicked_wishlist.product_id+'"]').eq(0).click();
              console.log("Button Clicked..!");
            }

          }, 500);

        }else{
          location.href = redirect_to;
        }
      }
    }
  });
  // End : Wishlist redirect user for login

  
  if(location.pathname.indexOf("/account") != -1){
    Flits(document).on('click', '.flits-custom-tab-add', function(e){    
      var elem = Flits(this).attr('href');
      var el = elem.replace('#', '');
      Flits('.flits-account-page-container').addClass('flits-active');

      Flits('.flits-nav-tabs li a').removeClass('flits-active');
      Flits('.flits-custom-tab-add').removeClass('flits-active');
      Flits('a[href="'+elem+'"]').addClass('flits-active');

      Flits('.flits-tab-box').removeClass('flits-active');
      Flits('#flits_tab_'+el).addClass('flits-active');
    });
  }
  Flits(document).on('click', '.flits-custom-open-login-drawer', function(event){ 
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    Flits("html").addClass("customer-show");
  });
  
  
  
   Flits(document).on('Flits:AccountPage:Loaded', function(event){     
    setInterval(()=>{ 
        document.querySelectorAll('.flits-pagination li a.page').forEach(item => {
          item.addEventListener('click', event => {
             document.body.scrollTop = 0; 
             document.documentElement.scrollTop = 0;
          })
        });
    },1000);    
  });

}(Flits));
